import React from "react";

export default function MSAccess_Trim() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Trim</h1>
      <p>This is the MSAccess_Trim component generated from the SQL JSON.</p>
    </div>
  );
}
